import React from 'react'
import { useIntl } from 'react-intl'
import { CellRenderer } from '../../../legacy-design-system/grid'
import { LoadingTextMask } from '../../../legacy-design-system/loading-masks'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Badge, BadgeColors } from '@contrast-security-inc/design-system-badges'

// prettier-ignore
export const statusMap = {
  BLOCK: {
    id: 'title_protectMode_block',
    color: 'green50'
  },
  BLOCK_AT_PERIMETER: {
    id: 'title_protectMode_blockAtPerimeter',
    color: 'green30'
  },
  MONITOR: {
    id: 'title_protectMode_monitor',
    color: 'neutral90'
  },
  MONITOR_AT_PERIMETER: {
    id: 'title_protectMode_monitorAtPerimeter',
    color: 'neutral90'
  },
  OFF_VALUE: {
    id: 'title_protectMode_off',
    color: 'neutral40'
  },
  NO_RULE_AVAILABLE: {
    id: 'title_noRuleAvailableToConfigure'
    // color handled explictly
  }
}

const ProtectStatusBadge = ({ status, env }) => {
  const intl = useIntl()
  const displayStatus = intl.formatMessage({
    id: !status // grouped by sink, no status for this row
      ? 'title_vulnSeverityTypeMultiple'
      : statusMap[status]?.id || statusMap['NO_RULE_AVAILABLE'].id
  })

  const tooltipValues = {
    env,
    mode: displayStatus
  }

  return !status || status === 'NO_RULE_AVAILABLE' ? (
    <Text color="neutral60" font="body" style={{ fontSize: '14px' }}>
      {displayStatus}
    </Text>
  ) : (
    <Tooltip
      body={intl.formatMessage({ id: 'tooltip_protectStatus' }, tooltipValues)}
    >
      <Badge
        style={{ fontWeight: 'bold' }}
        color={(statusMap[status]?.color || 'neutral90') as BadgeColors}
      >
        {displayStatus}
      </Badge>
    </Tooltip>
  )
}

interface Vulnerability {
  protectStatus: string
}

interface SinkGroup {
  protectStatus: string
}

interface RowData {
  vulnerability?: Vulnerability
  sinkGroup?: SinkGroup
}
export function getProtectStatusCellRenderer({
  protectAssessEnv
}): CellRenderer<RowData> {
  return ({ rowData }) => {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ProtectStatusBadge
          status={
            rowData?.sinkGroup
              ? rowData?.sinkGroup?.protectStatus
              : rowData?.vulnerability?.protectStatus
          }
          env={protectAssessEnv}
        />
      </div>
    )
  }
}

export const loadingProtectStatusCellRenderer = () => (
  <LoadingTextMask min={6} max={7} />
)
